import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkBadge, UitkBadgeTheme } from './uitk-badge.esm.js';
import { UitkBadgeSize } from '../types.esm.js';
var UitkSponsoredBadge = /** @class */function (_super) {
  __extends(UitkSponsoredBadge, _super);
  function UitkSponsoredBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkSponsoredBadge.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      hasBorder = _b.hasBorder;
    var cssClassNames = classNames(className, (_a = {}, _a["".concat(UitkBadge.baseClassName, "-has-border")] = hasBorder, _a));
    return React.createElement(UitkBadge, __assign({}, this.props, {
      size: UitkBadgeSize.SMALL,
      theme: UitkBadgeTheme.PROMOTED,
      className: cssClassNames
    }));
  };
  UitkSponsoredBadge.displayName = 'UitkSponsoredBadge';
  return UitkSponsoredBadge;
}(React.PureComponent);
export { UitkSponsoredBadge };